import { LANGUAGES } from './language/languages';

export const CONFIG = {
  OUR_NAME: 'Perfect Match',
  LOCALE: LANGUAGES.ENGLISH,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  HTTP_TIMEOUT_SECONDS: 60,
  PREFIX_URL: process.env.REACT_APP_PREFIX_URL || '',
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || '',
  TALENT_MAX_EDUCATION_ITEMS: 10,
  MATCH_CHECK_TALENT_VERSION_INTERVAL: 5000,
  SUBDOMAIN_NAME: '.goperfect.com',
};
